import { Modal } from "../modal/modal";

export interface IDrawer extends HTMLElement {
  showDrawer(): void;
  hideDrawer(): void;
}

export class Drawer extends Modal implements IDrawer {
  private direction: string;
  private closeDrawerButtons: HTMLElement[] | null = null;

  constructor() {
    super();
    this.direction = "left";
  }

  connectedCallback(): void {
    this.cacheDrawerDomElements();
    this.setDrawerEventListeners();
    super.connectedCallback();
    this.initializeDirection();
  }

  private cacheDrawerDomElements(): void {
    this.closeDrawerButtons = Array.from(
      this.querySelectorAll("[data-close-drawer]"),
    );
  }

  private setDrawerEventListeners(): void {
    if (this.closeDrawerButtons?.length) {
      this.closeDrawerButtons.forEach((button) => {
        button.addEventListener("click", () => {
          this.hideDrawer();
        });
      });
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.hideDrawer();
      }
    });
  }

  private initializeDirection(): void {
    const direction = this.getAttribute("drawer-direction");

    if (direction && ["left", "right", "top", "bottom"].includes(direction)) {
      this.direction = direction;
    }

    this.modal!.classList.add(`drawer--${this.direction}`);

    window.addEventListener("load", () => {
      this.classList.add("is-ready");
    });
  }

  public showDrawer(): void {
    this.classList.add("is-ready");

    super.showModal();
    this.applySlideInAnimation();
  }

  public hideDrawer(): void {
    super.hideModal();
    this.removeSlideInAnimation();
  }

  private applySlideInAnimation(): void {
    this.modal!.classList.add(`slide-in-${this.direction}`);
  }

  private removeSlideInAnimation(): void {
    this.modal!.classList.remove(`slide-in-${this.direction}`);
  }
}
